import { useSnackbar } from 'notistack';
import { useEffect, useState } from 'react';
import { createAxiosInstance } from 'src/utils/axios';
import RetailPaymentService from 'src/services/retailPaymentService';

const retailPaymentService = new RetailPaymentService(
    createAxiosInstance(process.env.REACT_APP_CASH_QORE_API)
);

/**
 * Custom hook to get refund reasons from Cash Qore API.
 * 
 *
 * @returns {{
 *   reasons: {
 *      refundReasonId: number,
 *      reason: string,
 *      isActive: boolean, 
 *      isInternal: boolean,
 *      notesRequired: boolean,
 *      stripeReason: string, 
 *      description: string
 *    }[],
 *    isLoading: boolean }}
 */
const useFetchRefundReasons = () => {
    const { enqueueSnackbar } = useSnackbar();
    const [reasons, setReasons] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const refresh = async () => {
        await fetchRefundReasons();
    };

    const fetchRefundReasons = async () => {
        setIsLoading(true);

        try {
            const refundReasons = await retailPaymentService
                .getRetailPaymentRefundReasons();
            setReasons(refundReasons.data);

        } catch (error) {
            enqueueSnackbar(`Failed fetching refund reasons. ${error?.message}`, {
                variant: 'error',
                preventDuplicate: true,
            });
        } finally {
            setIsLoading(false);
        }
    };


    useEffect(() => {
        fetchRefundReasons();
    }, []);


    return {
        isLoading,
        reasons,
        refresh,
    };
};



export default useFetchRefundReasons;
